import { getSelectedParcelsCount } from "../../../selectors/ui/routeDetail";
import { toggleSelectedStop } from "./stopFilters";

const ON_SELECT_PARCEL = "ON_SELECT_PARCEL";
const RESET_SELECTED_PARCELS = "RESET_SELECTED_PARCELS";

export const actionTypes = {
  ON_SELECT_PARCEL,
  RESET_SELECTED: RESET_SELECTED_PARCELS,
};

export const handleParcelSelect = (row) => ({
  type: ON_SELECT_PARCEL,
  payload: row,
});

export const handleParcelRowClick = ({ event, index, rowData }) => (
  dispatch,
  getState
) => {
  const selectedCount = getSelectedParcelsCount(getState());
  dispatch(toggleSelectedStop(rowData, index, event.shiftKey));
  selectedCount && dispatch(resetSelectedParcels());
};

export const resetSelectedParcels = () => ({ type: RESET_SELECTED_PARCELS });
